// Translation file for VersenytarsElemzes component
// Contains all UI text in Hungarian and English

export const VERSENYTARSELEMZES_TRANSLATIONS = {
    hu: {
        pageTitle: "10. Versenytárs elemzés",
        
        section101: {
            title: "10.1. Magyarországi versenytársak",
            description1: "A hazai versenytárs intézmények jelentkezési és felvett hallgatói létszám adatainak elemzése, értékelése.",
            description2: "A szak hazai versenytárs intézményeinek jelentkezési és felvételi adatait használhatják az elemzéshez.",
            source: "Forrás:",
            subtitle: "A szakkal közvetlen versenyben lévő hazai intézmények felsorolása:",
            subtitle1: "Jelentkezők száma alapján",
            subtitle2: "Versenyképesség értékelése",
        },
        
        section102: {
            title: "10.2. Nemzetközi benchmark",
            subtitle1: "Nevezze meg a szak öt legfontosabb nemzetközi versenytársát (oktatói, hallgatói létszám alapján, globális vagy regionális jelentőségű versenytárs)",
            subtitle2: "Kérjük mutassa be, milyen lehetőséget lát a nemzetközi együttműködésre (nyári egyetem, hallgatói, oktatói mobilitás, stb.) (több válasz is jelölhető)",
            subtitle3: "Jelenlegi partnerek, nemzetközi együttműködések típusa (több válasz is jelölhető)",
        },
        
        section103: {
            title: "10.3. A szak angol nyelvű képzési státusza",
            subtitle: "(Csak magyar nyelvű képzés esetén)",
        },
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden szöveges mezőt ki kell tölteni!"
        },
        
        modal: {
            imageAlt: "Nagyított kép",
            closeButton: "Bezárás"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    
    en: {
        pageTitle: "10. Competitor Analysis",
        
        section101: {
            title: "10.1. Domestic Competitors",
            description1: "Analysis and evaluation of the number of applicants and admitted students at competing domestic institutions.",
            description2: "Data on applications and admissions to competing domestic programmes may be used for the analysis.",
            source: "Source:",
            subtitle: "List of domestic institutions directly competing with the programme:",
            subtitle1: "Market position of the programme relative to competitors (based on number of applicants)",
            subtitle2: "Assessment of competitiveness",
        },
        
        section102: {
            title: "10.2. International Benchmark",
            subtitle1: "Please list the programme’s five most important international competitors (based on the number of academic staff and students, and global or regional relevance)",
            subtitle2: "Please describe the opportunities identified for international cooperation (e.g. summer schools, student mobility, staff mobility, etc.) (multiple answers may be selected)",
            subtitle3: "Current partners and types of international cooperation (multiple answers may be selected)",

        },
        
        section103: {
            title: "10.3. Status of English-Taught Provision within the Programme",
            subtitle: "(For Hungarian-taught programmes only)",
        },
        
        buttons: {
            previous: "Previous Section",
            next: "Next Section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Withdraw Finalization"
        },
        
        alerts: {
            requiredFields: "All text fields must be filled!"
        },
        
        modal: {
            imageAlt: "Enlarged image",
            closeButton: "Close"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};
